import { clearCookie } from '@rategravity/frontend/modules/hubspot';
import { event } from '@rategravity/frontend/modules/user-actions';
import { stringify } from 'querystring';
import React from 'react';
import Loading from '../../../components/dashboard/loading';
import RelayEnvironment from '../../../components/relay-environment';
import { CompleteMutation } from '../mutation';

/**
 * Commits the CompleteMutation to the RelayEnvironment,
 * which performs the GraphQL requery and syncs the store
 * with the response.
 *
 * @param { RxJS.ReplaySubject } actionPipe - Used to emit events to Mixpanel.
 * @param { object } viewer - Relay.QL store fragment
 */
const commitCompleteMutation = (actionPipe, viewer) => {
  const mutation = new CompleteMutation({ viewer });

  return new Promise((resolve, reject) =>
    RelayEnvironment.commitUpdate(mutation, {
      // onSuccess is invoked by RelayEnvironment.commitUpdate.
      // It receives as arguments the response from the RelayMutation
      // that was passed in.
      onSuccess: (...args) => {
        const scenario = mutation.props.viewer.activeLoan.scenario;
        const acceptedOffer = mutation.props.viewer.activeLoan.acceptedOffer;
        const consultPath = args[0].complete.viewer.consultPath;
        const products = args[0].complete.viewer.products;

        actionPipe.next(
          event('Complete CompleteMutation Query', {
            scenario,
            consultPath,
            products,
            acceptedOffer
          })
        );
        resolve();
      },
      onFailure: reject
    })
  );
};

/**
 * Abstraction for logic between the Thinking Screen and Relay.
 *
 * @param { RxJS.ReplaySubject } actionPipe - Used to emit events to Mixpanel.
 * @param { ReactRouter.Router } router - Used to implement navigation.
 * @param { string } path - String representing the base path in the URL.
 * @param { object } viewer - Relay.QL store fragment.
 * @param { string[] } messages - Messages to display for the Thinking Screen animation.
 */
export default ({ actionPipe, router, path, viewer, messages }) => (
  <Loading
    actionPipe={actionPipe}
    mutation={() => commitCompleteMutation(actionPipe, viewer)}
    done={() => {
      clearCookie();
      const queryStringParams = {};
      if (viewer.activeLoan) {
        queryStringParams.acceptedOffer = viewer.activeLoan.acceptedOffer;
      }
      router.replace(`/${path}/consult?${stringify(queryStringParams)}`);
    }}
    messages={messages}
  />
);



// WEBPACK FOOTER //
// ./src/products/shared/qualify/loading.js